import { MapPin } from "lucide-react";

export const addressText = (a) => {
  const line = a?.address_line1 || "";
  return [line, ...[a?.city, a?.state, a?.pincode].filter((v) => v && !line.toLowerCase().includes(v.toLowerCase()))].filter(Boolean).join(", ");
};

export function AddressCard({ a, testid = "address-card", children, compact }) {
  if (!a) return <div className="text-xs text-slate-400" data-testid={testid}>No dispatch address recorded</div>;
  const contact = [a.contact_person, a.contact_phone].filter(Boolean).join(" · ");
  return (
    <div className={`rounded border border-slate-200 bg-white ${compact ? "p-2" : "p-3"} text-xs`} data-testid={testid}>
      <div className="flex flex-wrap items-center gap-2">
        <MapPin className="h-3.5 w-3.5 text-sky-700" />
        <b className="text-slate-900 text-sm">{a.address_label}</b>
        <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] uppercase text-slate-600">{{ customer_site: "Customer site", customer_registration: "Customer registered address" }[a.source] || "One-off site"}</span>
        {children}
      </div>
      {a.consignee_name && <div className="mt-1 text-slate-800">Consignee: {a.consignee_name}{a.gstin ? ` · GSTIN ${a.gstin}` : ""}</div>}
      <div className="mt-0.5 text-slate-700">{addressText(a)}{a.country && a.country !== "India" ? `, ${a.country}` : ""}</div>
      {contact && <div className="mt-0.5 text-slate-600">Contact: {contact}</div>}
      {a.map_link && <a href={a.map_link} target="_blank" rel="noopener noreferrer" className="mt-1 inline-block text-sky-700 hover:underline" data-testid={`${testid}-map`}>Open Google location</a>}
      {!compact && a.notes && <div className="mt-1 text-slate-500">Note: {a.notes}</div>}
    </div>
  );
}
